<template>
</template>

<script>

import Personalizado from './Personalizado/Personalizado.js'
import FechasFunciones from './Fecha/FuncionesDeFecha.js'
const moment = require('moment');

export default {
    name: 'Personalizado',
    props: {

        Preguntas: Array,
        Formulario: String
    },
    mounted: function() {


        //----------------------------------------------------------------------------------
        //                ParteEspecífica para los asegurados de Salud
        //----------------------------------------------------------------------------------

        let aseg = ["1", "2", "3", "4", "5"];

        var LimiteEdadContratacion = 100;

        for (let dato of aseg) {

            //Fecha Nacimiento del Asegurado X
            var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("FechaNacimientoAsegurado"+dato, this.Preguntas);

            if (codigoPregunta["status"] == "OK")
            {

                let FechaMayordeEdad = moment(new Date()).subtract(0, 'years').format("YYYY-MM-DD");
                let FechaMasVieja = moment(new Date()).subtract(LimiteEdadContratacion, 'years').format("YYYY-MM-DD");
                let fechaTipo =  moment(new Date()).subtract(30, 'years').format("YYYY-MM-DD");

                var Pregunta = codigoPregunta.data;

                    Pregunta["maxDate"] = FechaMayordeEdad;
                    Pregunta["minDate"] = FechaMasVieja;
                    Pregunta["response"] = fechaTipo;
                    Pregunta["validate"] = true;

                var Mutation = {};
                    Mutation.formulario = this.Formulario;
                    Mutation.question = codigoPregunta.question;
                    Mutation.pregunta = Pregunta;

                this.$store.commit('actualizarCampoPregunta', Mutation);

            }


        }


        //Actualizar Número de Asegurados
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("NumeroAsegurados", this.Preguntas);

        if (codigoPregunta["status"] == "OK" && this.$store.state.NumeroAsegurados)
        {

            var Pregunta = codigoPregunta.data;

                Pregunta["response"] = this.$store.state.NumeroAsegurados;
                Pregunta["validate"] = true;

            var Mutation = {};
                Mutation.formulario = this.Formulario;
                Mutation.question = codigoPregunta.question;
                Mutation.pregunta = Pregunta;

            this.$store.commit('actualizarCampoPregunta', Mutation);

        }


        if (this.$store.state.asegurados)
        {

            if (this.$store.state.asegurados.length >= 1)
            {
                var indice = 1;
                for (let asegurado of this.$store.state.asegurados)
                {   

                    let nombre = asegurado.nombre;
                    let fechaNacimiento = asegurado.fechaNacimiento;

                    //Actualizar Nombres de los asegurados
                    let VariableNombre = "NombreAsegurado"+indice;
                    var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2(VariableNombre, this.Preguntas);

                    if (codigoPregunta["status"] == "OK")
                    {

                        var Pregunta = codigoPregunta.data;


                        if (Pregunta["allresponses"])
                        {

                            Pregunta["allresponses"]["name"] = nombre;

                        } else {

                            Pregunta["response"] = nombre;
                            Pregunta["validate"] = true;

                        }
                        
                        var Mutation = {};
                            Mutation.formulario = this.Formulario;
                            Mutation.question = codigoPregunta.question;
                            Mutation.pregunta = Pregunta;

                        this.$store.commit('actualizarCampoPregunta', Mutation);

                    }

                    //Actualizar fecha de Nacimiento de los asegurados
                    let Variablefechanacimiento = "FechaNacimientoAsegurado"+indice;
                    var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2(Variablefechanacimiento, this.Preguntas);

                    if (codigoPregunta["status"] == "OK")
                    {

                        var Pregunta = codigoPregunta.data;
                            Pregunta["response"] = fechaNacimiento;
                            Pregunta["validate"] = true;

                        
                        var Mutation = {};
                            Mutation.formulario = this.Formulario;
                            Mutation.question = codigoPregunta.question;
                            Mutation.pregunta = Pregunta;

                        this.$store.commit('actualizarCampoPregunta', Mutation);

                    }


                    var indice = (indice+1);



                }




            }



        }



        //----------------------------------------------------------------------------------
        //                ParteEspecífica para los asegurados de MASCOTAS
        //----------------------------------------------------------------------------------

        let asegMascotas = ["1", "2", "3"];

        for (let dato of asegMascotas) {

            //Fecha Nacimiento del Mascota X
            var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("FechaNacimientoMascota"+dato, this.Preguntas);
            if (codigoPregunta["status"] == "OK")
            {

                let FechaMasNueva = moment(new Date()).subtract(1, 'day').format("YYYY-MM-DD");
                let FechaMasVieja = moment(new Date()).subtract(25, 'years').format("YYYY-MM-DD");
                let fechaTipo =  moment(new Date()).subtract(2, 'years').format("YYYY-MM-DD");

                var Pregunta = codigoPregunta.data;

                    Pregunta["maxDate"] = FechaMasNueva;
                    Pregunta["minDate"] = FechaMasVieja;
                    Pregunta["response"] = fechaTipo;

                var Mutation = {};
                    Mutation.formulario = this.Formulario;
                    Mutation.question = codigoPregunta.question;
                    Mutation.pregunta = Pregunta;

                this.$store.commit('actualizarCampoPregunta', Mutation);
            }


        }

        //Actualizar Mascotas con los datos de la Base de Datos

        if (this.$store.state.asegurados)
        {

            if (this.$store.state.asegurados.length >= 1)
            {

                //Actualizar Número de Mascotas Aseguradas
                var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("NumeroMascotasAseguradas", this.Preguntas);
                if (codigoPregunta["status"] == "OK")
                {

                    var Pregunta = codigoPregunta.data;
                        Pregunta["response"] = this.$store.state.asegurados.length;
                        Pregunta["validate"] = true;
            
                    
                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);

                }


                var indice = 1;

                for (let asegurado of this.$store.state.asegurados)
                {   

                    let nombre = asegurado.nombre;
                    let fechaNacimiento = asegurado.fechaNacimiento;
                    let peso = asegurado.peso;
                    let tipologia = asegurado.tipologia;
                    let raza = asegurado.raza;
                    let ppp = asegurado.ppp;
                    let esterilizado = asegurado.esterilizado;
                    let sexoMascotas = asegurado.sexo;

                    //Actualizar Nombres de los asegurados
                    var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("NombreMascota"+indice, this.Preguntas);

                    if (codigoPregunta["status"] == "OK")
                    {

                        var Pregunta = codigoPregunta.data;
                            Pregunta["response"] = nombre;
                            Pregunta["validate"] = true;
                
                        
                        var Mutation = {};
                            Mutation.formulario = this.Formulario;
                            Mutation.question = codigoPregunta.question;
                            Mutation.pregunta = Pregunta;

                        this.$store.commit('actualizarCampoPregunta', Mutation);

                    }


                    //Actualizar fecha de Nacimiento de los asegurados
                    var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("FechaNacimientoMascota"+indice, this.Preguntas);

                    if (codigoPregunta["status"] == "OK")
                    {

                        var Pregunta = codigoPregunta.data;
                            Pregunta["response"] = fechaNacimiento;
                            Pregunta["validate"] = true;

                        
                        var Mutation = {};
                            Mutation.formulario = this.Formulario;
                            Mutation.question = codigoPregunta.question;
                            Mutation.pregunta = Pregunta;

                        this.$store.commit('actualizarCampoPregunta', Mutation);

                    }


                    if (peso != "ND"){
                        

                        //Actualizar Peso de los Asegurados
                        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("PesoMascota"+indice, this.Preguntas);

                        if (codigoPregunta["status"] == "OK")
                        {

                            var Pregunta = codigoPregunta.data;
                                Pregunta["response"] = peso;
                                Pregunta["validate"] = true;

                            
                            var Mutation = {};
                                Mutation.formulario = this.Formulario;
                                Mutation.question = codigoPregunta.question;
                                Mutation.pregunta = Pregunta;

                            this.$store.commit('actualizarCampoPregunta', Mutation);

                        }


                    }


                    if (sexoMascotas != "ND"){
                        

                        //Actualizar Sexo de los Asegurados
                        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("SexoMascota"+indice, this.Preguntas);

                        if (codigoPregunta["status"] == "OK")
                        {

                            var Pregunta = codigoPregunta.data;
                                Pregunta["response"] = sexoMascotas;
                                Pregunta["validate"] = true;

                            
                            var Mutation = {};
                                Mutation.formulario = this.Formulario;
                                Mutation.question = codigoPregunta.question;
                                Mutation.pregunta = Pregunta;

                            this.$store.commit('actualizarCampoPregunta', Mutation);

                        }


                    }

                    if (esterilizado != "ND"){
                        

                        //Actualizar Esterilizado de los Asegurados
                        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("MascotaEsterilizada"+indice, this.Preguntas);

                        if (codigoPregunta["status"] == "OK")
                        {

                            var Pregunta = codigoPregunta.data;
                                Pregunta["response"] = esterilizado;
                                Pregunta["validate"] = true;

                            
                            var Mutation = {};
                                Mutation.formulario = this.Formulario;
                                Mutation.question = codigoPregunta.question;
                                Mutation.pregunta = Pregunta;

                            this.$store.commit('actualizarCampoPregunta', Mutation);

                        }


                    }

                    if (tipologia != "ND"){

                        //Actualizar Tipologia de Animal
                        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("TipoMascota"+indice, this.Preguntas);

                        if (codigoPregunta["status"] == "OK")
                        {

                            var Pregunta = codigoPregunta.data;
                                Pregunta["response"] = tipologia;
                                Pregunta["validate"] = true;

                            
                            var Mutation = {};
                                Mutation.formulario = this.Formulario;
                                Mutation.question = codigoPregunta.question;
                                Mutation.pregunta = Pregunta;

                            this.$store.commit('actualizarCampoPregunta', Mutation);

                        }


                    }

                    if (ppp != "ND"){

                        //Actualizar PPP
                        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("PPP"+indice, this.Preguntas);
                        if (codigoPregunta["status"] == "OK")
                        {

                            var Pregunta = codigoPregunta.data;
                                Pregunta["response"] = ppp;
                                Pregunta["validate"] = true;

                            var Mutation = {};
                                Mutation.formulario = this.Formulario;
                                Mutation.question = codigoPregunta.question;
                                Mutation.pregunta = Pregunta;


                            this.$store.commit('actualizarCampoPregunta', Mutation);

                        }

                        if (tipologia == "ND" && ppp == "yes"){

                            //Actualizar Tipologia de Animal
                            var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("TipoMascota"+indice, this.Preguntas);

                            if (codigoPregunta["status"] == "OK")
                            {

                                var Pregunta = codigoPregunta.data;
                                    Pregunta["response"] = "Perro/a";
                                    Pregunta["validate"] = true;

                                
                                var Mutation = {};
                                    Mutation.formulario = this.Formulario;
                                    Mutation.question = codigoPregunta.question;
                                    Mutation.pregunta = Pregunta;

                                this.$store.commit('actualizarCampoPregunta', Mutation);

                            }

                        }

                    }

                    if (raza != "ND"){

                        //Actualizar Raza de Perro
                        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("RazaPerro"+indice, this.Preguntas);

                        if (codigoPregunta["status"] == "OK")
                        {

                            var Pregunta = codigoPregunta.data;
                                Pregunta["response"] = raza;
                                Pregunta["validate"] = true;


                            if (Pregunta["tipo"] == "AlgoliaSearchOne"){

                                Pregunta["answers"] = [{"data": raza, "title": raza}];

                            }
                            
                            var Mutation = {};
                                Mutation.formulario = this.Formulario;
                                Mutation.question = codigoPregunta.question;
                                Mutation.pregunta = Pregunta;

                            this.$store.commit('actualizarCampoPregunta', Mutation);

                        }

                        //Actualizar Raza de Gato
                        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("RazaGato"+indice, this.Preguntas);
                        if (codigoPregunta["status"] == "OK")
                        {

                            var Pregunta = codigoPregunta.data;
                                Pregunta["response"] = raza;
                                Pregunta["validate"] = true;

                            if (Pregunta["tipo"] == "AlgoliaSearchOne"){

                                Pregunta["answers"] = [{"data": raza, "title": raza}];

                            }

                            var Mutation = {};
                                Mutation.formulario = this.Formulario;
                                Mutation.question = codigoPregunta.question;
                                Mutation.pregunta = Pregunta;



                            this.$store.commit('actualizarCampoPregunta', Mutation);

                        }



                    }
                   


                    var indice = (indice+1);


                }




            }



        }

        //Actualizar Responsabilidad Civil
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("ResponsabilidadCivil", this.Preguntas);
        if (codigoPregunta["status"] == "OK" && this.$store.state.RC)
        {

            if (this.$store.state.RC != "ND")
            {

                var Pregunta = codigoPregunta.data;

                    Pregunta["response"] = this.$store.state.RC;
                    Pregunta["validate"] = true;

                var Mutation = {};
                    Mutation.formulario = this.Formulario;
                    Mutation.question = codigoPregunta.question;
                    Mutation.pregunta = Pregunta;

                this.$store.commit('actualizarCampoPregunta', Mutation);

            }

        }
        




        //----------------------------------------------------------------------------------
        //                Parte General para todos los formularios
        //----------------------------------------------------------------------------------
        

        //Existe el Nombre del Tomador Normal
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("NombreTomador", this.Preguntas);
        if (codigoPregunta["status"] == "OK" && this.$store.state.NombreTomador)
        {

            //Dispongo de Nombres y Apellidos por separado
            if (this.$store.state.NombreTomador.tipo == "PF")
            {


                if (codigoPregunta["data"]["tipo"] == "NombreCompleto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.completo;
                        Pregunta["validate"] = true;
                        Pregunta["allresponses"]["name"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["allresponses"]["surnames"] = this.$store.state.NombreTomador.apellidos;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);


                }


                if (codigoPregunta["data"]["tipo"] == "Texto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["validate"] = true;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);

                    
                }


            }

            if (this.$store.state.NombreTomador.tipo == "PJ")
            {

                if (codigoPregunta["data"]["tipo"] == "NombreCompleto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.completo;
                        Pregunta["validate"] = true;
                        Pregunta["allresponses"]["name"] = this.$store.state.NombreTomador.nombre;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);


                }


                if (codigoPregunta["data"]["tipo"] == "Texto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["validate"] = true;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);

                    
                }


            }


        }


        //Existe el Nombre del Tomador Salud Fisico
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("NombreTomadorPersona", this.Preguntas);
        if (codigoPregunta["status"] == "OK" && this.$store.state.NombreTomador)
        {

            //Dispongo de Nombres y Apellidos por separado
            if (this.$store.state.NombreTomador.tipo == "PF")
            {


                if (codigoPregunta["data"]["tipo"] == "NombreCompleto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.completo;
                        Pregunta["validate"] = true;
                        Pregunta["allresponses"]["name"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["allresponses"]["surnames"] = this.$store.state.NombreTomador.apellidos;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);


                }


                if (codigoPregunta["data"]["tipo"] == "Texto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["validate"] = true;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);

                    
                }


            }

            if (this.$store.state.NombreTomador.tipo == "PJ")
            {

                if (codigoPregunta["data"]["tipo"] == "NombreCompleto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.completo;
                        Pregunta["validate"] = true;
                        Pregunta["allresponses"]["name"] = this.$store.state.NombreTomador.nombre;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);


                }


                if (codigoPregunta["data"]["tipo"] == "Texto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["validate"] = true;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);

                    
                }


            }


        }

        //Existe el Nombre del Tomador Salud Jurídico
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("NombreTomadorSociedad", this.Preguntas);
        if (codigoPregunta["status"] == "OK" && this.$store.state.NombreTomador)
        {

            //Dispongo de Nombres y Apellidos por separado
            if (this.$store.state.NombreTomador.tipo == "PF")
            {


                if (codigoPregunta["data"]["tipo"] == "NombreCompleto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.completo;
                        Pregunta["validate"] = true;
                        Pregunta["allresponses"]["name"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["allresponses"]["surnames"] = this.$store.state.NombreTomador.apellidos;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);


                }


                if (codigoPregunta["data"]["tipo"] == "Texto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["validate"] = true;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);

                    
                }


            }

            if (this.$store.state.NombreTomador.tipo == "PJ")
            {

                if (codigoPregunta["data"]["tipo"] == "NombreCompleto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.completo;
                        Pregunta["validate"] = true;
                        Pregunta["allresponses"]["name"] = this.$store.state.NombreTomador.nombre;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);


                }


                if (codigoPregunta["data"]["tipo"] == "Texto")
                {

                    var Pregunta = codigoPregunta.data;

                        Pregunta["response"] = this.$store.state.NombreTomador.nombre;
                        Pregunta["validate"] = true;

                    var Mutation = {};
                        Mutation.formulario = this.Formulario;
                        Mutation.question = codigoPregunta.question;
                        Mutation.pregunta = Pregunta;

                    this.$store.commit('actualizarCampoPregunta', Mutation);

                    
                }


            }


        }
        


        //Actualizar Periodo Seleccionado
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("ModalidadPago", this.Preguntas);
        if (codigoPregunta["status"] == "OK" && this.$store.state.PeriodoSeleccionado)
        {

            var Pregunta = codigoPregunta.data;

                Pregunta["response"] = this.$store.state.PeriodoSeleccionado;
                Pregunta["validate"] = true;


            var Mutation = {};
                Mutation.formulario = this.Formulario;
                Mutation.question = codigoPregunta.question;
                Mutation.pregunta = Pregunta;

            this.$store.commit('actualizarCampoPregunta', Mutation);

        }

        //Fecha Nacimiento del Tomador
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("FechaNacimientoTomador", this.Preguntas);

        if (codigoPregunta["status"] == "OK")
        {

            if (this.$store.state.FechaNacimientoTomador){


                let FechaMayordeEdad = moment(new Date()).subtract(18, 'years').format("YYYY-MM-DD");
                let FechaMasVieja = moment(new Date()).subtract(90, 'years').format("YYYY-MM-DD");
                let Guardada = moment(this.$store.state.FechaNacimientoTomador).format("YYYY-MM-DD");

                var Pregunta = codigoPregunta.data;

                    Pregunta["maxDate"] = FechaMayordeEdad;
                    Pregunta["minDate"] = FechaMasVieja;
                    Pregunta["response"] = Guardada;
                    Pregunta["validate"] = true;


                var Mutation = {};
                    Mutation.formulario = this.Formulario;
                    Mutation.question = codigoPregunta.question;
                    Mutation.pregunta = Pregunta;

                this.$store.commit('actualizarCampoPregunta', Mutation);




            } else {


                let FechaMayordeEdad = moment(new Date()).subtract(18, 'years').format("YYYY-MM-DD");
                let FechaMasVieja = moment(new Date()).subtract(90, 'years').format("YYYY-MM-DD");
                let fechaTipo =  moment(new Date()).subtract(30, 'years').format("YYYY-MM-DD");

                var Pregunta = codigoPregunta.data;

                    Pregunta["maxDate"] = FechaMayordeEdad;
                    Pregunta["minDate"] = FechaMasVieja;
                    Pregunta["response"] = fechaTipo;
                    Pregunta["validate"] = true;


                var Mutation = {};
                    Mutation.formulario = this.Formulario;
                    Mutation.question = codigoPregunta.question;
                    Mutation.pregunta = Pregunta;

                this.$store.commit('actualizarCampoPregunta', Mutation);


            }


        }




        

        //Actualizar EmailTomador
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("EmailTomador", this.Preguntas);

        if (codigoPregunta["status"] == "OK" && this.$store.state.email)
        {

            var Pregunta = codigoPregunta.data;

                Pregunta["response"] = this.$store.state.email;
                Pregunta["validate"] = true;


            var Mutation = {};
                Mutation.formulario = this.Formulario;
                Mutation.question = codigoPregunta.question;
                Mutation.pregunta = Pregunta;

            this.$store.commit('actualizarCampoPregunta', Mutation);

        }

        //Actualizar TelefonoTomador
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("TelefonoTomador", this.Preguntas);

        if (codigoPregunta["status"] == "OK" && this.$store.state.telefono)
        {


            var Pregunta = codigoPregunta.data;

                Pregunta["response"] = this.$store.state.telefono;
                Pregunta["validate"] = true;


            var Mutation = {};
                Mutation.formulario = this.Formulario;
                Mutation.question = codigoPregunta.question;
                Mutation.pregunta = Pregunta;

            this.$store.commit('actualizarCampoPregunta', Mutation);

        }

        //---------------------------------------------------------------    
        // FECHAS DE EFECTO DE FORMULARIOS
        //----------------------------------------------------------------

        //Fecha de Efecto
        var codigoPregunta = Personalizado.buscarPreguntaporCodigoV2("FechaEfectoSeguro", this.Preguntas);


        if (codigoPregunta["status"] == "OK" && codigoPregunta["data"]["tipo"] == "FechaEfectoAsisaSalud")
        {


            let fechaActual =  String(moment(new Date()).format("YYYY-MM-DD"));

            let fechaHoy = FechasFunciones.pintarFechaMasCercanaAsisaSalud(fechaActual);
            
            let fechaMas1Anio = moment(fechaHoy).add(1, 'years').format("YYYY-MM-DD");
            let fechaAyer = moment(fechaHoy).subtract(15, 'days').format("YYYY-MM-DD");


            var Pregunta = codigoPregunta.data;

                Pregunta["maxDate"] = fechaMas1Anio;
                Pregunta["minDate"] = fechaAyer;
                Pregunta["response"] = fechaHoy;
                Pregunta["validate"] = true;

            var Mutation = {};
                Mutation.formulario = this.Formulario;
                Mutation.question = codigoPregunta.question;
                Mutation.pregunta = Pregunta;

            this.$store.commit('actualizarCampoPregunta', Mutation);

        } else {


            if (codigoPregunta["status"] == "OK"){


                let fechaActual =  String(moment(new Date()).format("YYYY-MM-DD"));
                let fechaLejana = moment(fechaActual).add(100, 'days').format("YYYY-MM-DD");
                let fechaManana = moment(fechaActual).add(1, 'days').format("YYYY-MM-DD");
                let fechaAyer = moment(fechaActual).subtract(1, 'days').format("YYYY-MM-DD");

                var Pregunta = codigoPregunta.data;

                    Pregunta["maxDate"] = fechaLejana;
                    Pregunta["minDate"] = fechaAyer;
                    Pregunta["response"] = fechaManana;
                    Pregunta["validate"] = true;

                var Mutation = {};
                    Mutation.formulario = this.Formulario;
                    Mutation.question = codigoPregunta.question;
                    Mutation.pregunta = Pregunta;

                this.$store.commit('actualizarCampoPregunta', Mutation);



            }


        }







        



        
        
    }
}
</script>
